export default "__VITE_ASSET__cd0adf58__"